import request from './adminRequest'

const authApi = {
  login (data) {
    return request.post('/employees/login', data)
  },
  signup (data) {
    return request.post('/employees/register', data)
  },
  checkToken () {
    return request.post('/employees/checkToken')
  },
}
export default authApi
